import {useContext} from 'react'
import Select, {SingleValue} from 'react-select'
import {EntityByProcessContext, IAssignmentDetail} from '../EntityByProcessContext'

const typeSync = {
  write: 'Escritura',
  read: 'Lectura',
  read_write: 'Lectura y escritura',
}

const optionsTypeSync = [
  {label: typeSync.read, value: 'read'},
  {label: typeSync.write, value: 'write'},
  {label: typeSync.read_write, value: 'read_write'},
]

export const DetailItem: React.FC<{detail: IAssignmentDetail}> = ({detail}) => {
  const {setDetailField, setChange} = useContext(EntityByProcessContext)

  const handleChangeOption = (selectedOption: SingleValue<{label: string; value: string}>) => {
    if (selectedOption) {
      const newValue = selectedOption.value // 'read', 'write', or 'read_write'
      setDetailField((prev) => {
        // Crear una copia del array de detalles
        const updatedDetails = prev.details.map((d) => {
          // Si no es el detalle que estamos buscando, lo devolvemos sin cambios
          if (
            d.ficha.id !== detail.ficha.id ||
            d.proceso.id !== detail.proceso.id ||
            d.seccion.id !== detail.seccion.id ||
            d.fieldId !== detail.fieldId
          ) {
            return d
          }

          // Si es el detalle que queremos actualizar, creamos una copia con los nuevos valores
          return {
            ...d,
            infoAssignments: {
              ...d.infoAssignments,
              isReadable: ['read', 'read_write'].includes(newValue),
              isWritable: ['write', 'read_write'].includes(newValue),
            },
          }
        })

        return {
          ...prev,
          details: updatedDetails,
        }
      })
      setChange(true)
    }
  }

  return (
    <tr>
      <td>{detail.proceso.nombre}</td>
      <td>{detail.ficha.nombre}</td>
      <td>{detail.seccion.nombre}</td>
      <td>{detail.fieldLabel}</td>
      <td>
        <Select
          options={optionsTypeSync}
          value={optionsTypeSync.find((option) => {
            if (detail.infoAssignments.isReadable && detail.infoAssignments.isWritable) {
              return option.value === 'read_write'
            } else if (detail.infoAssignments.isWritable) {
              return option.value === 'write'
            } else if (detail.infoAssignments.isReadable) {
              return option.value === 'read'
            }
            return false
          })}
          onChange={handleChangeOption}
        />
      </td>
    </tr>
  )
}
